<div class="form-actions button-container button-direction-column form-actions">
    <fs-ui-button routerLink="terms-and-conditions" [label]="'Términos y Condiciones'" [type]="'secondary'"></fs-ui-button>
</div>